document.addEventListener('DOMContentLoaded', function () {
  const unitBtns = document.querySelectorAll('.unit-btn');
  const unitLabels = document.querySelectorAll('.unit-label');
  const widthInput = document.getElementById('width-input');
  const heightInput = document.getElementById('height-input');
  const priceDisplay = document.getElementById('price-display');
  const finalPrice = document.getElementById('final-price');
  const calcAddToCart = document.getElementById('calc-add-to-cart');
  const calcBtnText = document.getElementById('calc-btn-text');
  const calcSpinner = document.getElementById('calc-spinner');
  const calcCartMessage = document.getElementById('calc-cart-message');
  const calcAreaDetail = document.getElementById('calc-area-detail');

  let currentUnit = 'cm';
  let currentTotalPrice = 0;

  const allVariants = JSON.parse(document.getElementById('wallpaper-variants-data').textContent);
  let productPrice = parseFloat(document.getElementById('wallpaper-price-data').dataset.price);

  function getSelectedVariantId() {
    const checkedVariantInput = document.querySelector('input[name="id"]');
    if (checkedVariantInput) return checkedVariantInput.value;

    const selectedColor = document.querySelector('input[name="Color"]:checked')?.value;
    const selectedPaper = document.querySelector('input[name="Paper type"]:checked')?.value;
    const matched = allVariants.find(v =>
      v.option1 === selectedColor && v.option2 === selectedPaper
    );
    return matched ? matched.id : allVariants[0]?.id;
  }

  function calculatePrice() {
    const width = parseFloat(widthInput.value);
    const height = parseFloat(heightInput.value);

    if (!width || !height) {
      priceDisplay.style.display = 'none';
      finalPrice.textContent = '';
      calcAddToCart.disabled = true;
      return;
    }

    let widthFt, heightFt;
    if (currentUnit === 'cm') {
      widthFt = width / 30.48;
      heightFt = height / 30.48;
    } else {
      widthFt = width / 12;
      heightFt = height / 12;
    }

    const area = widthFt * heightFt;
    const finalArea = Math.max(area, 30);
    currentTotalPrice = finalArea * productPrice;

    const areaSqmt = (widthFt * heightFt * 0.0929).toFixed(1);  // sq ft → sq mt
    const areaSqft = (widthFt * heightFt).toFixed(1);
    const appliedArea = area < 30 ? 30 : parseFloat(areaSqft);
    const appliedSqmt = (appliedArea * 0.0929).toFixed(1);

    calcAreaDetail.textContent = area < 30
      ? `Area: ${appliedSqmt} sq mt (${appliedArea} sq ft) · Minimum 30 sq ft applied`
      : `Area: ${areaSqmt} sq mt (${areaSqft} sq ft) · Includes 10% installation margin`;

    finalPrice.textContent = area < 30
      ? '₹' + currentTotalPrice.toFixed(2) + ' (minimum 30 sqft applied)'
      : '₹' + currentTotalPrice.toFixed(2);

    priceDisplay.style.display = 'block';
    calcAddToCart.disabled = false;

    document.getElementById('prop-width').value = width + ' ' + currentUnit;
    document.getElementById('prop-height').value = height + ' ' + currentUnit;
    document.getElementById('prop-price').value = '₹' + currentTotalPrice.toFixed(2);
    widthInput.name = 'properties[Width (' + currentUnit + ')]';
    heightInput.name = 'properties[Height (' + currentUnit + ')]';
  }

  calcAddToCart.addEventListener('click', function () {
    const width = parseFloat(widthInput.value);
    const height = parseFloat(heightInput.value);
    if (!width || !height) return;

    // Calculate sqft quantity
    let widthFt = currentUnit === 'cm' ? width / 30.48 : width / 12;
    let heightFt = currentUnit === 'cm' ? height / 30.48 : height / 12;
    const area = widthFt * heightFt;
    const finalArea = Math.ceil(Math.max(area, 30)); // ← add this
    const variantId = getSelectedVariantId();
    if (!variantId) {
      calcCartMessage.style.display = 'block';
      calcCartMessage.style.color = 'red';
      calcCartMessage.textContent = 'Please select a variant first.';
      return;
    }

    calcBtnText.classList.add('hidden');
    calcSpinner.classList.remove('hidden');
    calcAddToCart.disabled = true;


    const properties = {
      ['Width (' + currentUnit + ')']: width + ' ' + currentUnit,
      ['Height (' + currentUnit + ')']: height + ' ' + currentUnit,
      'Estimated Price': '₹' + currentTotalPrice.toFixed(2)
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties,
        sections: ['cart-notification-product', 'cart-icon-bubble', 'cart-drawer']
      })

    })
      .then(res => res.json())
      .then(data => {
        calcBtnText.classList.remove('hidden');
        calcSpinner.classList.add('hidden');
        calcAddToCart.disabled = false;

        console.log('Cart response data:', data);
        console.log('data.status:', data.status);


        if (data.status) {
          calcCartMessage.style.display = 'block';
          calcCartMessage.style.color = 'red';
          calcCartMessage.textContent = JSON.stringify(data);
        } else {
          // Show success message
          calcCartMessage.classList.remove('hidden');
          document.getElementById('calc-cart-message-text').textContent = 'The product has been added to the cart.';
          setTimeout(function () {
            calcCartMessage.classList.add('hidden');
          }, 4000);


          // Update cart icon bubble
          if (data.sections && data.sections['cart-icon-bubble']) {
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble) {
              const temp = document.createElement('div');
              temp.innerHTML = data.sections['cart-icon-bubble'];
              const newBubble = temp.querySelector('#cart-icon-bubble');
              if (newBubble) cartIconBubble.innerHTML = newBubble.innerHTML;
            }
          }

          // Open and refresh cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.renderContents({ sections: data.sections });
            cartDrawer.classList.remove('is-empty');
            cartDrawer.open(calcAddToCart);

            // Recalculate subtotal with estimated prices
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                let total = 0;
                cart.items.forEach(item => {
                  const estimatedPrice = item.properties['Estimated Price'];
                  if (estimatedPrice && estimatedPrice !== '') {
                    const numericPrice = parseFloat(estimatedPrice.replace(/[^0-9.]/g, ''));
                    total += numericPrice * item.quantity;
                  } else {
                    total += item.final_line_price / 100;
                  }
                });
                const subtotalEl = document.querySelector('.totals__subtotal-value');
                if (subtotalEl) {
                  subtotalEl.textContent = '₹' + total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
              });

          } else {
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) {
              cartNotification.setActiveElement(calcAddToCart);
              cartNotification.renderContents(data);
            }
          }
        }
      })
      .catch((err) => {
        calcBtnText.classList.remove('hidden');
        calcSpinner.classList.add('hidden');
        calcAddToCart.disabled = false;
        calcCartMessage.style.display = 'block';
        calcCartMessage.style.color = 'red';
        calcCartMessage.textContent = 'Error: ' + err.message;
        console.error('Cart add error:', err);
      });
  });

  widthInput.addEventListener('input', calculatePrice);
  heightInput.addEventListener('input', calculatePrice);

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('product-form__input__radio')) {
      setTimeout(function () {
        const selectedColor = document.querySelector('input[name="Color"]:checked')?.value;
        const selectedPaper = document.querySelector('input[name="Paper type"]:checked')?.value;

        const matched = allVariants.find(v =>
          v.option1 === selectedColor && v.option2 === selectedPaper
        );

        if (matched) {
          productPrice = matched.price / 100;
          const width = parseFloat(widthInput.value);
          const height = parseFloat(heightInput.value);
          if (width && height) {
            calculatePrice();
          }
        }
      }, 50);
    }
  });

  unitBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      unitBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      currentUnit = this.dataset.unit;
      unitLabels.forEach(label => label.textContent = currentUnit.toUpperCase());
      widthInput.placeholder = currentUnit === 'cm' ? 'e.g. 250 cm' : 'e.g. 80 in';
      heightInput.placeholder = currentUnit === 'cm' ? 'e.g. 300 cm' : 'e.g. 100 in';
      calculatePrice();
    });
  });
});




